import React, { useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Template from './template';
import * as S from './style';
import {
  SpaceDiv,
  BtnNext,
  FamilyMoveCarInfoRegister,
  BtnContainer,
} from 'components';
import { ReactComponent as IconPlus } from 'assets/img/common/ic_plus_2.svg';

import { ServiceState, ServiceAction } from 'stores/ServiceStore';
import { ServiceFamilyMoveState } from 'stores/ServiceFamilyMoveStore';
import { CarInfoState, CarInfoAction } from './store';
import { apiFamilyMoveRegister } from 'api/ZimssaAPI';
import {
  BUTTON_ADD_CARINFO,
  PAGE_SERVICE_FAMILYMOVE_REGISTER_TITLE,
  BUTTON_COMPLETE,
} from 'commons/ZimssaString';
import { getBusinessLicenseWithHyphen } from 'commons/ZimssaHelper';
import { SERVICE_SELECT } from 'router/PageUrl';

function FamilyMoveCarInfoRegistView(): React.ReactElement {
  const history = useHistory();
  const dispatcher = useContext(CarInfoAction);
  const serviceDispatcher = useContext(ServiceAction);

  const {
    serviceName,
    serviceImage,
    introduce,
    startYear,
    partnerServiceImages,
    businessRegistrationNumber,
    businessRegistrationImage,
    businessRegistrationOwner,
    taxClassification,
    familyRelationImage,
    location1,
    location2,
    serviceValid,
  } = useContext(ServiceState);

  const {
    isFranchise,
    franchiseName,
    arrangeLicenseImage,
    indemnityInsuranceImage,
    familyMoveValid,
    businessRegistrationName,
    businessRegistrationDetailAddress,
  } = useContext(ServiceFamilyMoveState);

  const { carInfoList, carInfoValid } = useContext(CarInfoState);

  const onClickRegisterCallback = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (serviceValid && familyMoveValid && carInfoValid) {
        apiFamilyMoveRegister({
          service: {
            serviceName: serviceName,
            serviceImage: serviceImage,
            introduce: introduce,
            startYear: startYear,
            partnerServiceImages: partnerServiceImages,
            businessRegistrationNumber: getBusinessLicenseWithHyphen(
              businessRegistrationNumber
            ),
            businessRegistrationImage: businessRegistrationImage,
            businessRegistrationOwner: businessRegistrationOwner,
            taxClassification: taxClassification,
            familyRelationImage: familyRelationImage,
            location1: location1,
            location2: location2,
          },
          familyMove: {
            isFranchise: isFranchise ? isFranchise : false,
            franchiseName: franchiseName,
            arrangeLicenseImage: arrangeLicenseImage,
            indemnityInsuranceImage: indemnityInsuranceImage,
            businessRegistrationName: businessRegistrationName, // 사업자 상호명
            businessRegistrationDetailAddress:
              businessRegistrationDetailAddress, // 사업자 상세주소
          },
          carInfo: carInfoList.map((item) => {
            return {
              size: item.size,
              type: item.type,
              etc: item.etc !== '' ? item.etc : '옵션없음',
              count: item.count,
            };
          }),
        })
          .then((response) => {
            const { result, message } = response;
            if (result === 'success') {
              alert('서류 제출을 완료 하였습니다.');
              serviceDispatcher({
                type: 'INIT_STATE',
              });
              history.push(SERVICE_SELECT.url);
            } else {
              if (message) alert(message);
            }
          })
          .catch((error) => {});
      }
    },
    [
      serviceValid,
      familyMoveValid,
      carInfoValid,
      serviceName,
      serviceImage,
      introduce,
      startYear,
      partnerServiceImages,
      businessRegistrationNumber,
      businessRegistrationImage,
      businessRegistrationOwner,
      taxClassification,
      familyRelationImage,
      location1,
      location2,
      isFranchise,
      franchiseName,
      arrangeLicenseImage,
      indemnityInsuranceImage,
      carInfoList,
      history,
      serviceDispatcher,
    ]
  );

  const btnNextProps = {
    contents: BUTTON_COMPLETE,
    isActive: serviceValid && familyMoveValid && carInfoValid,
    isComplete: false,
    onClick: onClickRegisterCallback,
  };

  return (
    <Template title={PAGE_SERVICE_FAMILYMOVE_REGISTER_TITLE}>
      {carInfoList.map((item, index) => (
        <FamilyMoveCarInfoRegister
          key={index}
          {...{
            carInfoKey: index,
            onClcikDelete: (
              e: React.MouseEvent<HTMLButtonElement, MouseEvent>
            ) => {
              dispatcher({
                type: 'DELETE',
                idx: item.idx,
              });
            },
            type: {
              inputName: 'type',
              onChangeHandler: (type: any, value: string) => {
                dispatcher({
                  type: 'MODIFY',
                  carInfo: {
                    ...item,
                    type: value,
                  },
                });
              },
            },
            size: {
              inputName: 'size',
              onChangeHandler: (type: any, value: string) => {
                dispatcher({
                  type: 'MODIFY',
                  carInfo: {
                    ...item,
                    size: value,
                  },
                });
              },
            },
            etc: {
              onChangeHandle: (value: string) => {
                dispatcher({
                  type: 'MODIFY',
                  carInfo: {
                    ...item,
                    etc: value,
                  },
                });
              },
            },
            count: {
              carInfo: `${item.type ? item.type : '종류없음'}/${
                item.size ? item.size : '사이즈없음'
              }/${item.etc ? item.etc : '옵션없음'}`,
              onClickHandler: (count: string | number) => {
                dispatcher({
                  type: 'MODIFY',
                  carInfo: {
                    ...item,
                    count: Number(count),
                  },
                });
              },
            },
          }}
        />
      ))}
      <S.BtnAddCarInfoWrapper>
        <S.BtnAddCarInfo
          backGroundColor={'blue_opacity_100'}
          height={44}
          color={'blue_900'}
          fontStyle={'body2'}
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            dispatcher({
              type: 'CREATE',
            });
          }}
        >
          <IconPlus />
          {BUTTON_ADD_CARINFO}
        </S.BtnAddCarInfo>
      </S.BtnAddCarInfoWrapper>
      <SpaceDiv height={24} />
      <BtnContainer>
        <BtnNext {...btnNextProps} />
      </BtnContainer>
    </Template>
  );
}

export default FamilyMoveCarInfoRegistView;
